import React, { useContext, useEffect, useRef } from 'react';
import { arrayUnion, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { UserContext } from '../contexts/UserContext';

const cointList = [
  {
    name: 'BTC / USDT',
    symbol: 'btcusdt',
  },
  {
    name: 'ETH / USDT',
    symbol: 'ethusdt',
  },
  {
    name: 'LTC / USDT',
    symbol: 'ltcusdt',
  },
  {
    name: 'BNB / USDT',
    symbol: 'bnbusdt',
  },
  {
    name: 'XRP / USDT',
    symbol: 'xrpusdt',
  },
  {
    name: 'EOS / USDT',
    symbol: 'eosusdt',
  },
  {
    name: 'TRX / USDT',
    symbol: 'trxusdt',
  },
  {
    name: 'ATOM / USDT',
    symbol: 'atomusdt',
  },
  {
    name: 'NEAR / USDT',
    symbol: 'nearusdt',
  },
  {
    name: 'MANA / USDT',
    symbol: 'manausdt',
  },
  {
    name: 'SOL / USDT',
    symbol: 'solusdt',
  },
  {
    name: 'SAND / USDT',
    symbol: 'sandusdt',
  },
];

const time = [
  {
    name: '1 minute',
    value: '1m',
  },
  {
    name: '3 minute',
    value: '3m',
  },
  {
    name: '5 minute',
    value: '5m',
  },
  {
    name: '15 minute',
    value: '15m',
  },
  {
    name: '30 minute',
    value: '30m',
  },
  {
    name: '1 hour',
    value: '1h',
  },
];

const stopLossRatio = [
  {
    name: '0.1',
    value: 0.1,
  },
  {
    name: '0.2',
    value: 0.2,
  },
  {
    name: '0.3',
    value: 0.3,
  },
  {
    name: '0.4',
    value: 0.4,
  },
  {
    name: '0.5',
    value: 0.5,
  },
  {
    name: '0.6',
    value: 0.6,
  },
  {
    name: '0.7',
    value: 0.7,
  },
  {
    name: '0.8',
    value: 0.8,
  },
  {
    name: '0.9',
    value: 0.9,
  },
  {
    name: '1',
    value: 1,
  },
  {
    name: '1.25',
    value: 1.25,
  },
  {
    name: '1.50',
    value: 1.5,
  },
  {
    name: '1.75',
    value: 1.75,
  },
  {
    name: '2',
    value: 2,
  },
];

const profitRatio = [
  {
    name: '0.1',
    value: 0.1,
  },
  {
    name: '0.25',
    value: 0.25,
  },
  {
    name: '0.5',
    value: 0.5,
  },
  {
    name: '1',
    value: 1,
  },
  {
    name: '1.5',
    value: 1.5,
  },
  {
    name: '2',
    value: 2,
  },
  {
    name: '2.5',
    value: 2.5,
  },
  {
    name: '3',
    value: 3,
  },
  {
    name: '3.5',
    value: 3.5,
  },
  {
    name: '4',
    value: 4,
  },
  {
    name: '4.5',
    value: 4.5,
  },

  {
    name: '5',
    value: 5,
  },
];

const PriceTable = () => {
  const userCtx = useContext(UserContext);

  const [currentSymbol, setCurrentSymbol] = React.useState(
    localStorage.getItem('currentSymbol') || 'btcusdt'
  );
  const [currentTime, setCurrentTime] = React.useState(
    localStorage.getItem('currentTime') || '5m'
  );
  const [currentStopLossRatio, setCurrentStopLossRatio] = React.useState(
    parseFloat(localStorage.getItem('currentStopLossRatio')) || 1
  );
  const [currentProfitRatio, setCurrentProfitRatio] = React.useState(
    parseFloat(localStorage.getItem('currentProfitRatio')) || 2
  );

  const [startTime, setStartTime] = React.useState(null);
  const [flipFlop, setFlipFlop] = React.useState(null);
  const [openPrice, setOpenPrice] = React.useState(null);
  const [currentPrice, setCurrentPrice] = React.useState(null);
  const [targetPrice, setTargetPrice] = React.useState(null);
  const [stopLossPrice, setStopLossPrice] = React.useState(null);
  const [state, setState] = React.useState(null);

  const [isLoading, setIsLoading] = React.useState(false);
  const [comingLoading, setComingLoading] = React.useState(true);

  const priceRef = useRef();
  const openRef = useRef();
  const startTimeRef = useRef();
  const endTimeRef = useRef();

  const [tempOpenPrice, setTempOpenPrice] = React.useState(null);
  const [tempStartTime, setTempStartTime] = React.useState(null);

  useEffect(() => {
    setIsLoading(true);
    let ws = new WebSocket(
      `wss://stream.binance.com:9443/ws/${currentSymbol}@kline_${currentTime}`
    );

    ws.onopen = () => {
      console.log('WebSocket opened');
      setIsLoading(false);
    };

    ws.onmessage = (event) => {
      const { k } = JSON.parse(event.data);
      openRef.current.innerText = k.o;
      priceRef.current.innerText = k.c;
      setCurrentPrice(parseFloat(k.c).toFixed(2));
      startTimeRef.current.innerText = new Date(k.t).toLocaleString();
      endTimeRef.current.innerText = new Date(k.T).toLocaleString();

      setTempOpenPrice(parseFloat(k.c).toFixed(2));
      setTempStartTime(new Date(k.t).toLocaleString());
    };

    ws.onclose = () => {
      console.log('WebSocket closed');
    };

    return () => {
      ws.close();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tempOpenPrice) {
      setComingLoading(false);
    }
  }, [tempOpenPrice]);

  useEffect(() => {
    if (!comingLoading) {
      console.log('tempOpenPrice', tempOpenPrice);
      setTimeout(() => {
        setOpenPrice(currentPrice);
        setStartTime(tempStartTime);

        const value = Math.random() > 0.5;
        setFlipFlop(value);

        let tempTarget = value
          ? +tempOpenPrice + (+tempOpenPrice * +currentProfitRatio) / 100
          : +tempOpenPrice - (+tempOpenPrice * +currentProfitRatio) / 100;
        setTargetPrice(tempTarget);

        let tempStopLoss = value
          ? +tempOpenPrice - (+tempOpenPrice * +currentStopLossRatio) / 100
          : +tempOpenPrice + (+tempOpenPrice * +currentStopLossRatio) / 100;
        setStopLossPrice(tempStopLoss);
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comingLoading]);

  useEffect(() => {
    if (currentPrice && targetPrice && stopLossPrice) {
      if (flipFlop) {
        setState(
          currentPrice >= targetPrice
            ? 'profit'
            : currentPrice <= stopLossPrice
            ? 'loss'
            : null
        );
      } else {
        setState(
          currentPrice <= targetPrice
            ? 'profit'
            : currentPrice >= stopLossPrice
            ? 'loss'
            : null
        );
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPrice]);

  useEffect(() => {
    if (state) {
      const data = {
        id: new Date().toISOString(),
        flipFlop: flipFlop,
        targetPrice: targetPrice,
        stopLossPrice: stopLossPrice,
        openPrice: openPrice,
        startTime: startTime,
        state: state,
        currentSymbol: currentSymbol.toString() || '',
      };

      const userRef = doc(db, 'users', userCtx.userId);

      updateDoc(userRef, {
        trades: arrayUnion(data),
      })
        .then(() => {
          console.log('Document successfully written!');
        })
        .catch((error) => {
          console.error('Error writing document: ', JSON.stringify(error));
        })
        .finally(() => {
          window.location.reload();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const handleChange = (e) => {
    setCurrentSymbol(e.target.value);
    localStorage.setItem('currentSymbol', e.target.value);
  };

  const handleTimeChange = (e) => {
    setCurrentTime(e.target.value);
    localStorage.setItem('currentTime', e.target.value);
  };

  useEffect(() => {}, [currentSymbol, currentTime]);

  const handleReset = () => {
    window.location.reload();
  };

  return (
    <div className="overflow-x-auto relative">
      <div className="my-2">
        <button
          className={`text-white font-bold py-1.5 px-3 rounded bg-green-600 hover:bg-gray-700
          `}
          onClick={handleReset}
        >
          Reset and set config
        </button>
      </div>
      <div className="flex gap-10 lg:flex-row flex-col">
        <div className="flex flex-col">
          <label htmlFor="symbol">Choose a symbol:</label>
          <select
            id="symbol"
            className="bg-white border border-gray-400 rounded-lg px-4 py-2"
            onChange={(e) => handleChange(e)}
            defaultValue={currentSymbol}
          >
            {cointList.map((coin) => (
              <option key={coin.symbol} value={coin.symbol}>
                {coin.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col ">
          <label htmlFor="time">Choose a time interval:</label>
          <select
            id="time"
            className="bg-white border border-gray-400 rounded-lg px-4 py-2"
            onChange={(e) => handleTimeChange(e)}
            defaultValue={currentTime}
          >
            {time.map((time) => (
              <option key={time.value} value={time.value}>
                {time.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col ">
          <label htmlFor="time">R/R Profit Ratio</label>
          <select
            id="time"
            className="bg-white border border-gray-400 rounded-lg px-4 py-2"
            defaultValue={currentProfitRatio}
            onChange={(e) => {
              setCurrentProfitRatio(e.target.value);
              localStorage.setItem('currentProfitRatio', e.target.value);
            }}
          >
            {profitRatio.map((time) => (
              <option key={time.value} value={time.value}>
                {time.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col ">
          <label htmlFor="time">R/R Stop-Loss Ratio</label>
          <select
            id="time"
            className="bg-white border border-gray-400 rounded-lg px-4 py-2"
            defaultValue={currentStopLossRatio}
            onChange={(e) => {
              setCurrentStopLossRatio(e.target.value);
              localStorage.setItem('currentStopLossRatio', e.target.value);
            }}
          >
            {stopLossRatio.map((time) => (
              <option key={time.value} value={time.value}>
                {time.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-5">
        {isLoading ? (
          <span className="text-xl">Loading...</span>
        ) : (
          <>
            <div className="overflow-x-auto flex flex-col gap-5">
              <h2 className="text-2xl font-semibold">
                {cointList.find((coin) => coin.symbol === currentSymbol).name}{' '}
                Price
              </h2>
              <table className="w-full border-collapse min-w-[800px]">
                <thead>
                  <tr>
                    <th className="border border-gray-400 px-4 py-2">
                      Current Price
                    </th>
                    <th className="border border-gray-400 px-4 py-2">
                      Open price
                    </th>
                    <th className="border border-gray-400 px-4 py-2">
                      Start Time
                    </th>
                    <th className="border border-gray-400 px-4 py-2">
                      End Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="text-center font-medium">
                    <td
                      className="border border-gray-400 px-4 py-2 text-green-600"
                      ref={priceRef}
                    ></td>
                    <td
                      className="border border-gray-400 px-4 py-2"
                      ref={openRef}
                    ></td>
                    <td
                      className="border border-gray-400 px-4 py-2"
                      ref={startTimeRef}
                    ></td>
                    <td
                      className="border border-gray-400 px-4 py-2"
                      ref={endTimeRef}
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      <div className="mt-5">
        {isLoading ? (
          <span className="text-xl">Loading...</span>
        ) : (
          <>
            <div className="overflow-x-auto flex flex-col gap-5">
              <h2 className="text-2xl font-semibold">Transaction</h2>
              <table className="w-full border-collapse min-w-[800px]">
                <thead>
                  <tr>
                    <th className="border border-gray-400 px-4 py-2">
                      Buy/Sell
                    </th>
                    <th className="border border-gray-400 px-4 py-2">
                      Target Price
                    </th>
                    <th className="border border-gray-400 px-4 py-2">
                      Stop Price
                    </th>
                    <th className="border border-gray-400 px-4 py-2">
                      Start price
                    </th>
                    <th className="border border-gray-400 px-4 py-2">
                      Start Time
                    </th>
                    <th className="border border-gray-400 px-4 py-2">State</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="text-center font-medium">
                    <td
                      className={`border border-gray-400 px-4 py-2 ${
                        flipFlop ? 'text-green-600' : 'text-red-500'
                      }`}
                    >
                      {flipFlop?.toString()}
                    </td>
                    <td
                      className={`border border-gray-400 px-4 py-2 ${
                        flipFlop ? 'text-green-600' : 'text-red-500'
                      }`}
                    >
                      {targetPrice}
                    </td>
                    <td
                      className={`border border-gray-400 px-4 py-2 ${
                        flipFlop ? 'text-green-600' : 'text-red-500'
                      }`}
                    >
                      {stopLossPrice}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {openPrice}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {startTime}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {state}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PriceTable;
